import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-020d16a7")

_pushScopeId("data-v-020d16a7")
const _hoisted_1 = {
  class: "top_serch",
  style: {"width":"1600px","margin":"0 auto"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("h5", {
  id: "report_scroll",
  class: "TitleStyle"
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("CPU查询性能问题 ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 确定")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_5 = /*#__PURE__*/_createVNode("h5", {
  id: "report_scroll",
  class: "TitleStyle"
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("查询项目性能数据 ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 确定")
const _hoisted_7 = /*#__PURE__*/_createVNode("h5", {
  id: "report_scroll",
  class: "TitleStyle"
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("查询版本数据 ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 确定")
const _hoisted_9 = /*#__PURE__*/_createVNode("h5", {
  id: "report_scroll",
  class: "TitleStyle"
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("查看问题汇总 ")
], -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 确定")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", null, [
                  _hoisted_2,
                  _createVNode(_component_el_form, {
                    inline: true,
                    size: "mini"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { label: "数据分类" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _ctx.cpuSerchChange,
                            modelValue: _ctx.cpu_type,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.cpu_type = $event)),
                            placeholder: "请选择",
                            clearable: "",
                            filterable: ""
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data_type, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.name,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["onChange", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "CPU名称" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _ctx.cpuSerchChange,
                            modelValue: _ctx.cpu_name,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.cpu_name = $event)),
                            placeholder: "请选择",
                            filterable: "",
                            "filter-method": _ctx.filterCpuList
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cpuList, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.cpu_name,
                                  label: item.cpu_name,
                                  value: item.cpu_name
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["onChange", "modelValue", "filter-method"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, {
                            size: "mini",
                            type: "primary",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cpu_btn()))
                          }, {
                            default: _withId(() => [
                              _hoisted_3
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode("div", null, [
                    _withDirectives(_createVNode(_component_el_table, {
                      size: "mini",
                      "header-cell-style": {
                  background: '#5D99D5',

                  color: '#fff',
                },
                      border: "",
                      data: 
                  _ctx.cpu_serch_data_store.data?.slice(
                    (_ctx.page - 1) * _ctx.size,
                    _ctx.page * _ctx.size
                  )
                
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_table_column, {
                          label: "CPU名称",
                          prop: "CPU名称"
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "设备",
                          prop: "设备"
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "场景",
                          prop: "场景"
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "版本",
                          prop: "版本"
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "用户占比",
                          prop: "用户占比"
                        }),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cpu_serch_data_store.project_list, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_table_column, {
                            label: item,
                            prop: "用户占比",
                            key: index
                          }, {
                            default: _withId((scope) => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(scope.row[item], (v, i) => {
                                return (_openBlock(), _createBlock("div", { key: i }, [
                                  _createVNode("div", null, [
                                    _createVNode("span", null, _toDisplayString(i + 1), 1),
                                    _hoisted_4,
                                    _createVNode("span", null, _toDisplayString(v), 1)
                                  ])
                                ]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["data"]), [
                      [_directive_loading, _ctx.cpu_loading]
                    ]),
                    _createVNode(_component_el_form, {
                      style: {"display":"flex","align-items":"center"},
                      inline: true,
                      size: "mini"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, {
                          style: {"margin-bottom":"0"},
                          label: "每页"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.size,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.size = $event)),
                              style: {"width":"55px","height":"28px"}
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          style: {"margin-bottom":"0"},
                          label: "条记录"
                        }),
                        _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                          default: _withId(() => [
                            _createVNode(_component_el_pagination, {
                              currentPage: _ctx.page,
                              "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => (_ctx.page = $event)),
                              "page-size": _ctx.size,
                              style: {"text-align":"right"},
                              total: _ctx.cpu_serch_data_store.data?.length,
                              layout: "total, prev, pager, next,jumper"
                            }, null, 8, ["currentPage", "page-size", "total"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createVNode("div", null, [
                  _hoisted_5,
                  _createVNode(_component_el_form, {
                    inline: true,
                    size: "mini"
                  }, {
                    default: _withId(() => [
                      _createVNode("div", null, [
                        _createVNode(_component_el_form_item, { label: "数据分类" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              onChange: _cache[6] || (_cache[6] = ($event: any) => (
                      _ctx.searchChange('project', ['scene', 'model', 'version'])
                    )),
                              modelValue: _ctx.project_type,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.project_type = $event)),
                              placeholder: "请选择",
                              clearable: "",
                              filterable: ""
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data_type, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.name,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "游戏项目" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              onChange: _cache[8] || (_cache[8] = ($event: any) => (
                      _ctx.searchChange('project', ['scene', 'model', 'version'])
                    )),
                              modelValue: _ctx.project_game,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.project_game = $event)),
                              placeholder: "请选择",
                              multiple: "",
                              "collapse-tags": "",
                              "collapse-tags-tooltip": "",
                              filterable: ""
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.topProjectScenes, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: item.project_name,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "场景选择" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.searchChange('project', ['model', 'version']))),
                              modelValue: _ctx.project_scene,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.project_scene = $event)),
                              placeholder: "请选择",
                              multiple: "",
                              "collapse-tags": "",
                              "collapse-tags-tooltip": "",
                              filterable: ""
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sceneList, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item,
                                    label: item,
                                    value: item
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode("div", null, [
                        _createVNode(_component_el_form_item, { label: "设备选择" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.searchChange('project', ['version']))),
                              modelValue: _ctx.project_model,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.project_model = $event)),
                              placeholder: "请选择",
                              multiple: "",
                              "collapse-tags": "",
                              "collapse-tags-tooltip": "",
                              filterable: ""
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.topProjectModel, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.model_name,
                                    label: item.model_name,
                                    value: item.model_name
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "版本选择" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.project_version,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.project_version = $event)),
                              placeholder: "请选择"
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.versionList, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item,
                                    label: item,
                                    value: item
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "指标选择" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.project_param,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.project_param = $event)),
                              placeholder: "请选择",
                              multiple: "",
                              "collapse-tags": "",
                              "collapse-tags-tooltip": "",
                              filterable: ""
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.TOPParams, (item, k, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item,
                                    value: item
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: "primary",
                              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.project_btn()))
                            }, {
                              default: _withId(() => [
                                _hoisted_6
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _withDirectives(_createVNode(_component_el_table, {
                    size: "mini",
                    "header-cell-style": {
                background: '#5D99D5',

                color: '#fff',
              },
                    data: 
                _ctx.project_data?.data?.slice(
                  (_ctx.project_page - 1) * _ctx.project_size,
                  _ctx.project_page * _ctx.project_size
                )
              
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_table_column, {
                        label: "设备",
                        prop: "设备名称"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "挡位",
                        prop: "档位"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "CPU",
                        prop: "CPU"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "GPU",
                        prop: "GPU"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "用户占比",
                        prop: "用户占比"
                      }),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.project_data?.body, (item, key, i) => {
                        return (_openBlock(), _createBlock(_component_el_table_column, {
                          label: key,
                          key: i
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(item, (v) => {
                              return (_openBlock(), _createBlock(_component_el_table_column, {
                                label: v,
                                key: v
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.project_param, (name) => {
                                    return (_openBlock(), _createBlock(_component_el_table_column, {
                                      label: name,
                                      key: name
                                    }, {
                                      default: _withId((scope) => [
                                        _createTextVNode(_toDisplayString(name !== "是否闪退"
                          ? scope.row[key][v][name]
                          : scope.row[key][v][name] == true
                          ? "是"
                          : "否"), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["data"]), [
                    [_directive_loading, _ctx.project_loading]
                  ]),
                  _createVNode(_component_el_form, {
                    style: {"display":"flex","align-items":"center"},
                    inline: true,
                    size: "mini"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, {
                        style: {"margin-bottom":"0"},
                        label: "每页"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.project_size,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.project_size = $event)),
                            style: {"width":"55px","height":"28px"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        style: {"margin-bottom":"0"},
                        label: "条记录"
                      }),
                      _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                        default: _withId(() => [
                          _createVNode(_component_el_pagination, {
                            currentPage: _ctx.project_page,
                            "onUpdate:currentPage": _cache[18] || (_cache[18] = ($event: any) => (_ctx.project_page = $event)),
                            "page-size": _ctx.project_size,
                            style: {"text-align":"right"},
                            total: _ctx.project_data?.data?.length,
                            layout: "total, prev, pager, next,jumper"
                          }, null, 8, ["currentPage", "page-size", "total"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("div", null, [
                  _hoisted_7,
                  _createVNode(_component_el_form, {
                    inline: true,
                    size: "mini"
                  }, {
                    default: _withId(() => [
                      _createVNode("div", null, [
                        _createVNode(_component_el_form_item, { label: "数据分类" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.version_type,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.version_type = $event)),
                              placeholder: "请选择",
                              filterable: "",
                              onChange: _cache[20] || (_cache[20] = ($event: any) => (
                      _ctx.searchChange('version', ['scene', 'model', 'version'])
                    ))
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data_type, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.name,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "游戏项目" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              onChange: _cache[21] || (_cache[21] = ($event: any) => (
                      _ctx.searchChange('version', ['scene', 'model', 'version'])
                    )),
                              modelValue: _ctx.version_game,
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.version_game = $event)),
                              placeholder: "请选择"
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.topProjectScenes, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: item.project_name,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "场景选择" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.searchChange('version', ['model', 'version']))),
                              modelValue: _ctx.version_scene,
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.version_scene = $event)),
                              placeholder: "请选择"
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sceneList_version, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item,
                                    label: item,
                                    value: item
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode("div", null, [
                        _createVNode(_component_el_form_item, { label: "设备选择" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.version_model,
                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.version_model = $event)),
                              placeholder: "请选择",
                              multiple: "",
                              onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.searchChange('version', ['version']))),
                              "collapse-tags": "",
                              "collapse-tags-tooltip": "",
                              filterable: ""
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.topProjectModel_version, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.model_name,
                                    label: item.model_name,
                                    value: item.model_name
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "版本选择" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.version_version,
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.version_version = $event)),
                              placeholder: "请选择",
                              multiple: "",
                              "collapse-tags": "",
                              "collapse-tags-tooltip": "",
                              filterable: ""
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.versionList_version, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item,
                                    label: item,
                                    value: item
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "指标选择" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.version_param,
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.version_param = $event)),
                              placeholder: "请选择",
                              multiple: "",
                              "collapse-tags": "",
                              "collapse-tags-tooltip": "",
                              filterable: ""
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.TOPParams, (item, k, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item,
                                    value: item
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: "primary",
                              onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.version_btn()))
                            }, {
                              default: _withId(() => [
                                _hoisted_8
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode(_component_el_table, {
                          size: "mini",
                          "header-cell-style": {
                    background: '#5D99D5',

                    color: '#fff',
                  },
                          data: 
                    _ctx.version_data?.data?.slice(
                      (_ctx.page_version - 1) * _ctx.size_version,
                      _ctx.page_version * _ctx.size_version
                    )
                  
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, {
                              label: '游戏项目' + _ctx.version_game + 'Top历史数据'
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_table_column, {
                                  label: "档位",
                                  prop: "档位"
                                }),
                                _createVNode(_component_el_table_column, {
                                  label: "设备",
                                  prop: "设备名称"
                                }),
                                _createVNode(_component_el_table_column, {
                                  label: "CPU",
                                  prop: "CPU"
                                }),
                                _createVNode(_component_el_table_column, {
                                  label: "GPU",
                                  prop: "GPU"
                                }),
                                _createVNode(_component_el_table_column, {
                                  label: "用户占比",
                                  prop: "用户占比"
                                }),
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.version_data?.version_list, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_table_column, {
                                    key: item,
                                    label: '迭代版本' + item
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.version_param, (name) => {
                                        return (_openBlock(), _createBlock(_component_el_table_column, {
                                          label: name,
                                          key: name
                                        }, {
                                          default: _withId((scope) => [
                                            _createTextVNode(_toDisplayString(name !== "是否闪退"
                              ? scope.row[item][name]
                              : scope.row[item][name] == true
                              ? "是"
                              : "否"), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["label"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["label"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["data"]), [
                          [_directive_loading, _ctx.version_loading]
                        ]),
                        _createVNode(_component_el_form, {
                          style: {"display":"flex","align-items":"center"},
                          inline: true,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, {
                              style: {"margin-bottom":"0"},
                              label: "每页"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.size_version,
                                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.size_version = $event)),
                                  style: {"width":"55px","height":"28px"}
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              style: {"margin-bottom":"0"},
                              label: "条记录"
                            }),
                            _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                              default: _withId(() => [
                                _createVNode(_component_el_pagination, {
                                  currentPage: _ctx.page_version,
                                  "onUpdate:currentPage": _cache[31] || (_cache[31] = ($event: any) => (_ctx.page_version = $event)),
                                  "page-size": _ctx.size_version,
                                  style: {"text-align":"right"},
                                  total: _ctx.version_data?.data?.length,
                                  layout: "total, prev, pager, next,jumper"
                                }, null, 8, ["currentPage", "page-size", "total"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("div", null, [
                  _hoisted_9,
                  _createVNode(_component_el_form, {
                    inline: true,
                    size: "mini"
                  }, {
                    default: _withId(() => [
                      _createVNode("div", null, [
                        _createVNode(_component_el_form_item, { label: "游戏项目" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              onChange: _cache[32] || (_cache[32] = ($event: any) => (_ctx.problemChange())),
                              modelValue: _ctx.problem_game,
                              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.problem_game = $event)),
                              placeholder: "请选择"
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.topProjectScenes, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: item.project_name,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "数据分类" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.problem_type,
                              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.problem_type = $event)),
                              placeholder: "请选择",
                              filterable: "",
                              onChange: _cache[35] || (_cache[35] = ($event: any) => (_ctx.problemChange()))
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data_type, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.name,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "版本选择" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.problem_version,
                              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.problem_version = $event)),
                              placeholder: "请选择"
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.prolblemVersionList_version, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item,
                                    label: item,
                                    value: item
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: "primary",
                              onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.problem_btn()))
                            }, {
                              default: _withId(() => [
                                _hoisted_10
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode("div", null, [
                        _withDirectives(_createVNode(_component_el_table, {
                          size: "mini",
                          border: "",
                          "header-cell-style": {
                    background: '#5D99D5',

                    color: '#fff',
                  },
                          data: 
                    _ctx.problemData?.data?.slice(
                      (_ctx.problem_page - 1) * _ctx.problem_size,
                      _ctx.problem_page * _ctx.problem_size
                    )
                  
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, {
                              label: "设备序号",
                              index: _ctx.indexMethod2(0),
                              type: "index"
                            }, null, 8, ["index"]),
                            _createVNode(_component_el_table_column, {
                              label: "设备型号",
                              prop: "设备型号"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "分档信息",
                              prop: "分档信息"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "默认画质",
                              prop: "默认画质"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "用户占比",
                              prop: "用户占比"
                            }),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.problemData.scene_list, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_table_column, {
                                label: item,
                                key: index
                              }, {
                                default: _withId((scope) => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(scope.row[item], (j, i) => {
                                    return (_openBlock(), _createBlock("div", { key: i }, [
                                      _createVNode("span", null, _toDisplayString(i + 1) + "、" + _toDisplayString(j), 1)
                                    ]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["data"]), [
                          [_directive_loading, _ctx.problem_loading]
                        ]),
                        _createVNode(_component_el_form, {
                          style: {"display":"flex","align-items":"center"},
                          inline: true,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, {
                              style: {"margin-bottom":"0"},
                              label: "每页"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.problem_size,
                                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.problem_size = $event)),
                                  style: {"width":"55px","height":"28px"}
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              style: {"margin-bottom":"0"},
                              label: "条记录"
                            }),
                            _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                              default: _withId(() => [
                                _createVNode(_component_el_pagination, {
                                  currentPage: _ctx.problem_page,
                                  "onUpdate:currentPage": _cache[39] || (_cache[39] = ($event: any) => (_ctx.problem_page = $event)),
                                  "page-size": _ctx.problem_size,
                                  style: {"text-align":"right"},
                                  total: _ctx.problemData?.data?.length,
                                  layout: "total, prev, pager, next,jumper"
                                }, null, 8, ["currentPage", "page-size", "total"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})